import React, { forwardRef } from 'react';
import classnames from 'classnames';
import s from './StickyContent.scss';

export interface Props {
  isStuck: boolean;
  className?: string;
  zIndex?: number;
  marginTop?: number;
  marginLeft?: number;
  top?: number;
  children: (isStuck: boolean) => React.ReactNode;
}

const StickyContent = forwardRef<HTMLDivElement, Props>(
  ({ isStuck, className, zIndex, marginTop = 0, marginLeft = 0, top = 0, children }, innerRef) => {
    return (
      <div
        className={classnames(
          s['content'],
          isStuck && s['stuck'],
          !isStuck && s['unstuck'],
          isStuck && className
        )}
        style={{
          zIndex,
          marginTop: isStuck ? marginTop : undefined,
          marginLeft: isStuck ? marginLeft : undefined,
          top: isStuck ? top : undefined,
        }}
        ref={innerRef}
      >
        {children(isStuck)}
      </div>
    );
  }
);
StickyContent.displayName = 'StickyContent';

export default React.memo(StickyContent);
